import { c as _c } from "react/compiler-runtime";
import { Button } from "@flat-ui";
import { useMediaQueryList } from "@hooks/use-media-query";
/**
 * Reusable invite member button component.
 * Renders either a filled primary Button or an outlined secondary Button based on variant.
 */
export function InviteMemberButton(t0) {
  const $ = _c(7);
  const {
    buttonVariant: t1,
    onClick,
    shouldUseAutoWidth: t2
  } = t0;
  const buttonVariant = t1 === undefined ? "outlined" : t1;
  const shouldUseAutoWidth = t2 === undefined ? false : t2;
  const {
    isScreenLgOrLarger
  } = useMediaQueryList();
  if (buttonVariant === "filled") {
    const width = !shouldUseAutoWidth && !isScreenLgOrLarger ? "100%" : "auto";
    let t3;
    if ($[0] !== width) {
      t3 = {
        width
      };
      $[0] = width;
      $[1] = t3;
    } else {
      t3 = $[1];
    }
    let t4;
    if ($[2] !== onClick || $[3] !== t3) {
      t4 = <Button onClick={onClick} sx={t3}>Invite members</Button>;
      $[2] = onClick;
      $[3] = t3;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    return t4;
  }
  let t3;
  if ($[5] !== onClick) {
    t3 = <Button variant="secondary" onClick={onClick}>Invite members</Button>;
    $[5] = onClick;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}